<template>
  <div>
    <div>
      <div v-if="loading" class="overlay">
        <div>
          <img class="spinner" src="loading.gif" alt="Loading data..." />
        </div>
      </div>

      <div v-else-if="isolatedState === 0">
        <h1 style="text-transform: uppercase; text-align: left">
          Validação Ato Isolado
        </h1>
        <div class="button-container" id="container-contact">
          <div class="container">
            <div class="row align-items-center">
              <div class="message-section" id="align-center">
                <div class="flex-container-emissao" id="no-pad-left">
                  <h2 class="close-request">Requisições fechadas</h2>
                  <img
                    src="img/requisicoes_fechadas.png"
                    alt="Fechado"
                    class="icon-size-submition"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else-if="
          $auth.check(['dashboard.accounts']) && dsr_payment_method === 2
        "
      >
        <!-- Dados sobre Pontos -->
        <div id="movpoints">
          <h1 style="text-transform: uppercase; text-align: left">
            Validação Ato Isolado
          </h1>
          <div class="card-list">
            <div class="card">
              <div class="card-content">
                <div
                  style="
                    background: #fff;
                    padding: 12px;
                    border-radius: 10px;
                    margin-bottom: 20px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <p style="font-weight: bold; margin: 0; font-size: medium">
                    Zona: {{ zoneName || "-" }}
                  </p>

                  <p
                    style="font-weight: bold; margin: 0"
                    :style="{ color: zoneStatus === 'ok' ? 'green' : 'red' }"
                  >
                    Estado: {{ zoneStatus ? zoneStatus.toUpperCase() : "-" }}
                  </p>
                </div>

                <h4
                  style="
                    margin-bottom: 0;
                    background-color: #f48c4f;
                    color: white;
                    padding: 12px;
                    border-radius: 10px;
                    max-width: 75%;
                  "
                >
                  Ano correspondente: {{ lastYear }}
                </h4>

                <table
                  style="
                    width: 100%;
                    margin-top: 20px;
                    border-collapse: collapse;
                  "
                >
                  <thead>
                    <tr style="border-bottom: 2px solid #ccc; text-align: left">
                      <th style="padding: 8px">Tipo</th>
                      <th style="padding: 8px">Pontos</th>
                      <th style="padding: 8px">Estado</th>
                      <th style="padding: 8px">Ação</th>
                    </tr>
                  </thead>

                  <tbody>
                    <!-- UFS -->
                    <tr style="border-bottom: 1px solid #eee">
                      <td style="padding: 8px; font-weight: bold">UFS</td>

                      <td style="padding: 8px">
                        {{ points.ufs.original }}
                      </td>

                      <td style="padding: 8px">
                        <span
                          v-if="points.ufs.state === null"
                          style="font-weight: bold"
                          >Por aprovar</span
                        >
                        <span
                          v-else-if="points.ufs.state === 'ok'"
                          style="color: green; font-weight: bold"
                          >OK</span
                        >
                        <span
                          v-else-if="points.ufs.state === 'nok'"
                          style="color: red; font-weight: bold"
                          >NOK</span
                        >
                        <span v-else>-</span>
                      </td>

                      <td style="padding: 8px">
                        <!-- APPROVED -->
                        <button
                          v-if="points.ufs.state === 'ok'"
                          style="font-weight: bold"
                          class="btn-disabled"
                          disabled
                        >
                          Aprovado
                        </button>

                        <!-- ACTIONS -->
                        <div v-else style="display: flex; gap: 8px">
                          <button
                            :disabled="submitting"
                            @click="approve('ufs')"
                            style="
                              background: #28a745;
                              color: white;
                              border: none;
                              border-radius: 6px;
                              width: 36px;
                              height: 36px;
                              font-size: 18px;
                              cursor: pointer;
                            "
                          >
                            ✓
                          </button>

                          <button
                            :disabled="submitting"
                            @click="reject('ufs')"
                            style="
                              background: #dc3545;
                              color: white;
                              border: none;
                              border-radius: 6px;
                              width: 36px;
                              height: 36px;
                              font-size: 18px;
                              cursor: pointer;
                            "
                          >
                            ✕
                          </button>
                        </div>
                      </td>
                    </tr>

                    <!-- OLA -->
                    <tr>
                      <td style="padding: 8px; font-weight: bold">OLA</td>

                      <td style="padding: 8px">
                        {{ points.ola.original }}
                      </td>

                      <td style="padding: 8px">
                        <span
                          v-if="points.ola.state === null"
                          style="font-weight: bold"
                          >Por aprovar</span
                        >
                        <span
                          v-else-if="points.ola.state === 'ok'"
                          style="color: green; font-weight: bold"
                          >OK</span
                        >
                        <span
                          v-else-if="points.ola.state === 'nok'"
                          style="color: red; font-weight: bold"
                          >NOK</span
                        >
                        <span v-else>-</span>
                      </td>

                      <td style="padding: 8px">
                        <!-- APPROVED -->
                        <button
                          v-if="points.ola.state === 'ok'"
                          class="btn-disabled"
                          style="font-weight: bold"
                          disabled
                        >
                          Aprovado
                        </button>

                        <!-- ACTIONS -->
                        <div v-else style="display: flex; gap: 8px">
                          <button
                            :disabled="submitting"
                            @click="approve('ola')"
                            style="
                              background: #28a745;
                              color: white;
                              border: none;
                              border-radius: 6px;
                              width: 36px;
                              height: 36px;
                              font-size: 18px;
                              cursor: pointer;
                            "
                          >
                            ✓
                          </button>

                          <button
                            :disabled="submitting"
                            @click="reject('ola')"
                            style="
                              background: #dc3545;
                              color: white;
                              border: none;
                              border-radius: 6px;
                              width: 36px;
                              height: 36px;
                              font-size: 18px;
                              cursor: pointer;
                            "
                          >
                            ✕
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- TOTAL -->
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin-top: 20px;
                    margin-bottom: 0;
                    height: 20px;
                  "
                >
                  <p>Total:</p>
                  <p style="font-weight: bold; color: #f48c4f">
                    {{ totalPoints }}
                  </p>
                </div>

                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 0;
                    height: 20px;
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/vue@2.6.14/dist/vue.js"></script>
<script>
import axios from "axios"; // Import axios here
import Vue from "vue";
import VModal from "vue-js-modal";
import "vue-js-modal/dist/styles.css";

Vue.use(VModal);

export default {
  name: "emissao",
  components: {},
  data() {
    return {
      previousYear: new Date().getFullYear() - 1, // gives the previous year
      lastYear: null,
      points: {
        ufs: { headers: [], original: 0, state: null },
        ola: { headers: [], original: 0, state: null },
      },
      zoneName: null,
      zoneStatus: null,
      submissionStateCode: null,
      isolatedState: null,
      submitting: false,
      image: null,
      data: null,
      loading: true,
      user: null,
      hasLoadedMore: false,
      isLeader: false,
      user_id: null,
      dsr_id: null,
      dsr_payment_method: null,
      uploadedFile: null,
    };
  },

  computed: {
    totalPoints() {
      return (
        ((this.points && this.points.ufs && this.points.ufs.original) || 0) +
        ((this.points && this.points.ola && this.points.ola.original) || 0)
      );
    },

    totalValue() {
      let total = 0.01 * this.totalPoints;
      let rounded = total.toFixed(2);
      return rounded;
    },
  },

  async mounted() {
    try {
      this.loading = true;
      await this.fetchPointsActoIsolado();
      await this.fetchDsrId();
      await this.fetchZoneDsrStatus();
      await this.fetchName();
      // await this.formatName();

      this.loading = false;
    } catch (error) {
      console.error("Error during initialization:", error);
      this.loading = false;
    }
  },

  methods: {
    approve(type) {
      if (this.submitting) return;

      this.points[type].state = "ok";
      this.sendDecision();
    },

    reject(type) {
      if (this.submitting) return;

      this.points[type].state = "nok";
      this.sendDecision();
    },

    mapStateToBackend(state) {
      if (state === "ok") return "1";
      if (state === "nok") return "0";
      return "2";
    },

    checkAndRefreshIfApproved() {
      if (this.points.ufs.state === "ok" && this.points.ola.state === "ok") {
        // Small delay to ensure backend commit
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    },

    async sendDecision() {
      if (this.submitting) return;

      this.submitting = true;

      try {
        const payload = {
          ufs_points: this.points.ufs.original,
          ufs_status: this.mapStateToBackend(this.points.ufs.state),
          ola_points: this.points.ola.original,
          ola_status: this.mapStateToBackend(this.points.ola.state),
          total: this.totalPoints,
        };

        const response = await axios.post(
          "app/createIsolatedCheckForPrincipalDsr",
          payload
        );

        console.log("Decision saved:", response.data);

        if (
          response.data &&
          response.data.message === "Isolated check locked"
        ) {
          return;
        }

        this.checkAndRefreshIfApproved();
      } catch (error) {
        console.error("Error saving decision:", error);
      } finally {
        this.submitting = false;
      }
    },

    formatName(fullName) {
      if (!fullName) return ""; // Retorna vazio se o nome não existir
      const names = fullName.trim().split(" ");
      if (names.length === 1) return names[0]; // Apenas um nome
      return `${names[0]} ${names[names.length - 1]}`; // Primeiro e último
    },

    getRunningBalance(index) {
      // Start with saldoOla as the base
      let balance = this.saldo;

      // Sum the total_points up to the current index
      for (let i = this.sortedPointsData.length - 2; i >= index; i--) {
        balance += parseFloat(this.sortedPointsData[i].total_points);
      }

      return balance;
    },

    async fetchPointsActoIsolado() {
      try {
        const response = await axios.get(`app/getIsolatedLast`);

        if (response.status === 200 && response.data) {
          const { ufs, ola, lastYear } = response.data;

          // Validate the structure before assigning
          this.points = {
            ufs: ufs || { headers: [], original: 0, exception: null },
            ola: ola || { headers: [], original: 0, exception: null },
          };
          this.lastYear = lastYear || null;
        } else {
          console.error("Failed to fetch data:", response);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async fetchZoneDsrStatus() {
      try {
        const response = await axios.get("app/getZoneDsrStatus");

        if (!response.data) return;

        // Zone info
        this.zoneName = response.data.zone_name || null;
        this.zoneStatus = response.data.status || null;

        // Principal DSR point states
        this.points.ufs.state =
          response.data.dsr_ufs_status === "1"
            ? "ok"
            : response.data.dsr_ufs_status === "0"
            ? "nok"
            : null;

        this.points.ola.state =
          response.data.dsr_ola_status === "1"
            ? "ok"
            : response.data.dsr_ola_status === "0"
            ? "nok"
            : null;
      } catch (error) {
        console.error("Error fetching zone DSR status:", error);
      }
    },

    fetchDsrId() {
      this.loading = true;
      this.error = null;
      this.dsr_id = null;
      this.dsr_payment_method = null;

      this.axios
        .get("app/getDsrId")
        .then((response) => {
          // Assuming response.data contains the object with the name field
          this.dsr_id = response.data.dsr_id;
          this.dsr_payment_method = response.data.payment_method;
          this.loading = false;
        })
        .catch((error) => {
          this.error = error.message;
          this.loading = false;
        });
    },

    fetchName() {
      this.loading = true;
      this.error = null;
      this.user = null;
      this.user_id = null;

      this.axios
        .get("app/getInfo")
        .then((response) => {
          // Assuming response.data contains the object with the name field
          this.user = response.data.name;
          this.user_id = response.data.user;
          this.loading = false;
        })
        .catch((error) => {
          this.error = error.message;
          this.loading = false;
        });
    },
  },
};
</script>

<style>
.icon-size-submition {
  width: 40px;
}

.flex-container-emissao {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-left: 15px;
}

#no-pad-left {
  padding-left: 0px;
  padding-bottom: 15px;
}

.text {
  flex-grow: 1;
  text-align: left;
  color: #fff;
  font-size: 18px;
}

.icon img {
  width: 40px;
}

p {
  font-size: 18px;
}

.spinner {
  width: 80px;
  height: 80px;
  text-align: center;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 50% opacity grey */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Make sure it's on top of everything */
}

.text-confirmation {
  color: orange;
}

.text-danger {
  color: red;
}

.text-success {
  color: green;
}

.text-replaced {
  color: rgb(0, 255, 255);
}

.text-warning {
  color: orange;
}

.bold {
  font-weight: 500;
}

.error {
  color: red;
}

button:disabled {
  opacity: 1.6;
  cursor: not-allowed;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 30px 0px 10px 0px;
  scrollbar-width: none !important;
  /* Oculta a barra de rolagem */
}

#app::-webkit-scrollbar {
  display: none !important;
  /* Para Chrome, Safari e outros navegadores baseados em WebKit */
}

#form-contact .form-group {
  margin-bottom: 15px;
}

.points-container {
  display: flex;
}

#form-contact .form-name {
  width: 100%;
  /* padding: 10px; */
  font-size: 14px;
  min-height: 5vh;
  max-height: 5vh;
}

#form-contact .form-anexo {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  height: auto;
  min-height: 2vh;
}

#form-contact .btn {
  padding: 10px 20px;
  font-size: 14px;
}

#form-contact .btn-delete {
  color: white;
  background-color: red;
  border: 0px;
  border-radius: 4px;
  font-size: 14px;
}

#form-contact .form-nome {
  margin-top: -10px;
}

#form-contact .modal-container {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  max-width: 500px;
  width: 90%;
  margin: auto;
}

#form-contact .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#form-contact .modal-title {
  margin: 0;
}

#form-contact .close {
  cursor: pointer;
}

#form-contact .modal-body {
  padding: 0 0;
  padding-top: 20px;
}

#form-contact h2 {
  font-size: 16px;
  margin-top: 5px;
}

#align-center {
  text-align: left;
}

.close-request {
  font-size: 18px !important;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

#form-contact .modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  max-width: 500px;
  width: 90%;
  margin: auto;
}

#form-contact .close-btn {
  color: #c26e00;
  border: none;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  background: none;
  cursor: pointer;
}

#form-contact .custom-file-upload {
  position: relative;
  display: inline-block;
}

#form-contact .custom-file-upload input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

#form-contact .border-box {
  border: 1px solid #e4e7ea;
  border-radius: 5px;
  padding: 10px;
  /*background-color: #f8f9fa;*/
  margin-bottom: 20px;
  font-size: 16px;
}

#form-contact .custom-file-upload label {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  text-align: center;
}

.intro h2 {
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 10px;
}

#movpoints .card {
  /* width: 300px; */
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

#movpoints .card-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

#movpoints .card-list {
  display: block;
  width: 100%;
}

#container-contact {
  background: linear-gradient(240.74deg, #c26e00 0%, #af3f00 100%);
  border-radius: 15px;
  padding-top: 20px;
  padding-left: 5px;
  padding-right: 5px;
}

#container-contact .contact-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

#container-contact .message-section {
  flex: 1;
  /*padding-right: 20px;*/
  padding: 5px 5px 5px 5px;
}

#container-contact .image-section {
  /*flex: 0.3;
  text-align: right;*/
  width: max-content;
}

#container-contact .image-section img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

#container-contact .btn-primary {
  background-color: #fff;
  color: #f48c4f;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  border-radius: 10px;
}

#container-contact .btn-primary:hover {
  background-color: #f48c4f;
  color: #fff;
}

#form-contact .btn-primary {
  background-color: #f48c4f;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  width: 100%;
}

#form-contact .custom-file-upload {
  position: relative;
  display: inline-block;
}

#form-contact .custom-file-upload input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

#form-contact .custom-file-upload label {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  text-align: center;
}

#form-contact .btn-primary:hover {
  background-color: #c26e00;
  color: #fff;
}

#container-contact h2 {
  color: #fff;
  font-size: 16px;
}

#container-contact p {
  color: #666;
  font-size: 16px;
}

#container-contact .button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

#form-feedback .modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

#form-feedback .modal-content h2 {
  margin-top: 0;
}

#form-feedback .btn {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #f48c4f;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

#form-feedback .btn:hover {
  background-color: #c26e00;
  color: #fff;
}

#download .title {
  margin-top: 20px;
  margin-bottom: 20px;
}

#download .btn-primary {
  background-color: #fff;
  color: #c26e00;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  width: 60%;
  margin-top: 30px;
  text-transform: uppercase;
  margin-left: 20%;
  margin-right: 20%;
  margin-bottom: 30px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 50% opacity grey */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Make sure it's on top of everything */
}

#download .btn-primary:hover {
  background-color: #f48c4f;
  color: #fff;
}

/* @media (max-width: 767px) {
  body {
    overflow-y: auto !important;
    height: 100vh; 
    scrollbar-width: none !important; 
  }
  
  body::-webkit-scrollbar {
    display: none !important; 
  }
} */
.red {
  color: red;
}

.green {
  color: #00c939;
}

.yellow {
  color: orange;
}

body {
  margin: 0;
  padding: 0;
  height: 100vh;
  /* Garante que ocupe toda a altura da tela */
}

.btn-approve {
  background: #4caf50;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
}

.btn-reject {
  background: #f44336;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
}
</style>
